import { RECIPIENT_PHONE_RULE_MESSAGES } from './merchant'

export const ERRORS_MESSAGE_MAPPER: Record<string, any> = {
  'address not found': 'ข้อมูลที่อยู่ไม่ถูกต้อง',
  'add tags not found': 'ไม่พบข้อมูลแท็ก หรือ กรอกแท็กซ้ำ',
  'all leads are in blacklist':
    'รายชื่อลูกค้าใน ข้อมูลลีดทั้งหมดอยู่ในรายการ Blacklist',
  'bangkok province is invalid': 'กรุณาระบุชื่อเต็มของกรุงเทพมหานคร',
  'category not found': 'ไม่พบหมวดหมู่',
  'merchant not found': 'ไม่พบร้านค้า',
  'merchant config not found': 'ไม่พบการตั้งค่าร้านค้า',
  'daily order limit reached': 'จำนวนคำสั่งซื้อต่อวัน เกินที่กำหนด',
  'distribution channel not found': 'ไม่พบช่องทางการขาย',
  'district is invalid': 'ข้อมูลอำเภอไม่ถูกต้อง',
  'district not found': 'ไม่พบข้อมูลอำเภอ',
  'cannot create tracking': 'ไม่สามารถสร้างหมายเลขพัสดุได้',
  'category limit reached': 'จำนวนหมวดหมู่ เกินที่กำหนด',
  'category code has already been taken': 'ชื่อหมวดหมู่ถูกใช้งานแล้ว',
  'product group name has already been taken': 'ชื่อกลุ่มสินค้าถูกใช้งานแล้ว',
  'some products were not found': 'ไม่พบสินค้าบางรายการ',
  'product group not found': 'ไม่พบกลุ่มสินค้า',
  'channel not found': 'ไม่พบช่องทางการขาย',
  'employee limit reached': 'จำนวนพนักงาน เกินที่กำหนด',
  'error get products': 'ไม่สามารถดึงสินค้าจากระบบได้',
  'lead limit reached': 'จำนวนลีด เกินที่กำหนด',
  'lead import excel not found': 'ไม่พบข้อมูลที่สามารถนำเข้าได้',
  'lead is exists': 'มีข้อมูลแล้วในระบบ',
  'lead user not found': 'ไม่พบข้อมูลผู้ดูแลลีดในระบบ (ช่อง AddBy)',
  'lead not found': 'ไม่พบข้อมูลลีด',
  'lead channel not found': 'ไม่พบข้อมูลช่องทางการขาย',
  'merchant already expired': 'ร้านค้านี้หมดอายุแล้ว กรุณาติดต่อผู้ดูแลระบบ',
  'order not found': 'ไม่พบคำสั่งซื้อ',
  'order limit reached': 'จำนวนคำสั่งซื้อ เกินที่กำหนด',
  'order is cod, total lass than 1':
    'คำสั่งซื้อเป็นเก็บเงินปลายทาง ราคารวมต้องมากกว่า 0',
  'phone number is invalid': 'หมายเลขโทรศัพท์ไม่ถูกต้อง (ต้องมี 9-10 หลัก)',
  'phone number should start with 0': 'หมายเลขโทรศัพท์ควรขึ้นต้นด้วย 0',
  'phone number should not start with 66':
    'หมายเลขโทรศัพท์ไม่ควรขึ้นต้นด้วย 66',
  'phone number is required': 'หมายเลขโทรศัพท์เป็นข้อมูลที่จำเป็น',
  ...Object.fromEntries(
    Object.values(RECIPIENT_PHONE_RULE_MESSAGES).map((message) => [
      message,
      message,
    ]),
  ),
  'pipeline not found': 'ไม่พบข้อมูล pipeline',
  'please solve recaptcha': 'กรุณายืนยันตัวตนด้วย reCAPTCHA',
  'product limit reached': 'จำนวนรายการสินค้า เกินที่กำหนด',
  'product code has already been taken': 'รหัสสินค้าถูกใช้งานแล้ว',
  'product not found': 'ไม่พบสินค้า',
  'province not found': 'ไม่พบข้อมูลจังหวัด',
  'sub district not found': 'ไม่พบข้อมูลตำบล',
  'tiktok account limit reached': 'จำนวนบัญชี TikTok เกินที่กำหนด',
  'tracking already proceed':
    'ไม่สามารถยกเลิกหมายเลขพัสดุสินค้าได้ เนื่องจากสินค้าได้ดำเนินการโดยขนส่งแล้ว',
  'user already exists': 'ชื่อผู้ใช้ถูกใช้งานแล้ว',
  'Username should contain only lowercase letters and numbers':
    'ชื่อผู้ใช้ต้องประกอบด้วยตัวอักษรพิมพ์เล็กและตัวเลขเท่านั้น',
  'ThrottlerException: Too Many Requests':
    'Too Many Requests ระบบกำลังประมวลผลข้อมูล กรุณารอสักครู่',
  'Timeout has occurred':
    'การเชื่อมต่อเกินเวลาที่กำหนดไว้ ข้อมูลที่อาจจะได้รับการบันทึกแล้ว กรุณาตรวจสอบใหม่อีกครั้ง',
  'You are not allowed to delete items that are not yours':
    'คุณไม่สามารถลบสินค้าที่ไม่เป็นของคุณได้',
  'zipcode not found': 'ไม่พบข้อมูลรหัสไปรษณีย์',
  'zipcode is invalid': 'รหัสไปรษณีย์ไม่ถูกต้อง',
}

export const ERRORS_MESSAGE_MAPPER_DATA: Record<string, any> = {
  validZipcode: 'รหัสไปรษณีย์ที่ถูกต้อง',
  validProvince: 'กรุณาระบุชื่อเต็มของจังหวัด',
  validDistrict: 'ข้อมูลอำเภอไม่ถูกต้อง',
  validSubDistrict: 'ข้อมูลตำบลไม่ถูกต้อง',
  bestMatch: 'ข้อมูลที่ใกล้เคียงที่สุด',
}
